import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NgCommonModule } from '@principle-theorem/ng-shared';
import {
  AccToothInjuryClassification,
  IAccClaim,
} from '@principle-theorem/principle-core/interfaces';
import { DATE_WITH_YEAR } from '@principle-theorem/shared';

@Component({
  selector: 'pr-acc-claim-details-display',
  imports: [NgCommonModule],
  templateUrl: './acc-claim-details-display.component.html',
  styleUrl: './acc-claim-details-display.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccClaimDetailsDisplayComponent {
  claimData = input.required<IAccClaim>();
  dateFormat = DATE_WITH_YEAR;

  injuryClassificationLabel(
    injuryClassification: AccToothInjuryClassification[]
  ): string {
    return injuryClassification.join(', ');
  }
}
